export const topMeels=[
    {
        image:"https://cdn.pixabay.com/photo/2021/12/30/11/33/italian-cuisine-6903774_1280.jpg",
        title:"Pizza"
    },
    {
        image:"https://cdn.pixabay.com/photo/2021/01/19/08/47/sandwich-5930496_1280.jpg",
        title:"Burger"
    },
    {
        image:"https://cdn.pixabay.com/photo/2016/11/29/04/00/bread-1867208_1280.jpg",
        title:"Sandwich"
    },
    {
        image:"https://cdn.pixabay.com/photo/2015/10/01/14/26/fried-rice-967081_1280.jpg",
        title:"Fried Rice"
    },
    {
        image:"https://cdn.pixabay.com/photo/2014/08/26/12/49/the-cake-427920_1280.jpg",
        title:"Cake"
    },
    {
        image:"https://media.istockphoto.com/id/1345624337/photo/chicken-biriyani.jpg?s=612x612&w=0&k=20&c=Y5eymzBSwmNeARyJr479sR6mWQvah56TBpWhC4Aof5o=",
        title:"Biryani"
    },
    {
        image:"https://cdn.pixabay.com/photo/2024/01/23/10/02/thali-8527370_1280.jpg",
        title:"Thali"
    },
    {
        image:"https://cdn.pixabay.com/photo/2021/02/28/09/38/food-6056720_1280.jpg",
        title:"North Indian Food"
    },
    {
        image:"https://cdn.pixabay.com/photo/2018/03/15/12/16/food-3228057_1280.jpg",
        title:"Rolls"
    },
    {
        image:"https://cdn.pixabay.com/photo/2017/06/28/17/40/chicken-2451482_1280.jpg",
        title:"Chicken"
    },
    {
        image:"https://cdn.pixabay.com/photo/2021/12/29/23/39/spicy-noodle-6902956_1280.jpg",
        title:"Noodles"
    },
    {
        image:"https://cdn.pixabay.com/photo/2016/10/25/13/42/indian-1768906_1280.jpg",
        title:"Dosa"
    },

]